import { defineComponent as p, mergeModels as f, createPropsRestProxy as v, useId as h, useModel as y, useTemplateRef as w, ref as k, onMounted as x, createElementBlock as u, openBlock as m, normalizeProps as g, guardReactiveProps as B, unref as r, createVNode as M, createCommentVNode as P, mergeProps as V, normalizeClass as b, renderSlot as C, createTextVNode as S, toDisplayString as T } from "vue";
import { useBindCx as R } from "@scalar/use-hooks/useBindCx";
import { useResizeObserver as _ } from "@vueuse/core";
import z from "./ScalarMarkdown.vue.js";
import "./ScalarMarkdown.vue2.js";
const N = ["aria-controls", "aria-expanded"], E = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "ScalarMarkdownSummary",
  props: /* @__PURE__ */ f({
    value: {},
    withImages: { type: Boolean },
    withAnchors: { type: Boolean },
    transform: { type: Function },
    transformType: {},
    clamp: { default: 1 },
    anchorPrefix: {}
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const c = v(t, ["clamp"]), l = h(), o = y(t, "modelValue"), n = w("scalar-markdown"), s = k(!1);
    _(() => {
      var e;
      return (e = n.value) == null ? void 0 : e.el;
    }, i);
    function i() {
      var a;
      const e = (a = n.value) == null ? void 0 : a.el;
      e && (s.value = e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);
    }
    x(i);
    const { cx: d } = R();
    return (e, a) => (m(), u("div", g(B(
      r(d)(
        "group/summary flex gap-0.5",
        o.value ? "flex-col" : "flex-row items-baseline"
      )
    )), [
      M(z, V({ ref: "scalar-markdown" }, c, {
        id: r(l),
        class: { "markdown-summary truncate": !o.value },
        clamp: o.value ? void 0 : e.clamp
      }), null, 16, ["id", "class", "clamp"]),
      s.value || o.value ? (m(), u("button", {
        key: 0,
        class: b(["whitespace-nowrap font-medium hover:underline", { "self-end": o.value }]),
        type: "button",
        "aria-controls": r(l),
        "aria-expanded": o.value,
        onClick: a[0] || (a[0] = ($) => o.value = !o.value)
      }, [
        C(e.$slots, "button", { open: o.value }, () => [
          S(T(o.value ? " Show Less" : "More"), 1)
        ])
      ], 10, N)) : P("", !0)
    ], 16));
  }
});
export {
  E as default
};
